export const documentTypes = ["passport", "driverLicence", "localAddress", "otherDocument"];
